import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const ctfCategoryPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    ctf: {
      pages: {
        categories: {
          title: "赛题分类",
          subtitle: "维护 CTF 赛题分类，并保留完整审计字段与后端筛选。",
          createAction: "新建分类",
          createTitle: "新建赛题分类",
          createSuccess: "分类已创建",
          archiveAction: "归档分类",
          archiveConfirmTitle: "确认归档该分类吗？",
          archiveConfirmDescription: "归档后该分类不能继续创建新赛题，历史赛题和审计记录会保留。",
          archiveSuccess: "分类已归档",
          loadFailed: "加载赛题分类失败"
        }
      }
    }
  },
  en: {
    ctf: {
      pages: {
        categories: {
          title: "Categories",
          subtitle: "Maintain CTF challenge categories with audit fields and backend filters.",
          createAction: "Create category",
          createTitle: "Create category",
          createSuccess: "Category created",
          archiveAction: "Archive category",
          archiveConfirmTitle: "Archive this category?",
          archiveConfirmDescription: "Archived categories cannot receive new challenges; history and audit records remain.",
          archiveSuccess: "Category archived",
          loadFailed: "Failed to load categories"
        }
      }
    }
  },
  ja: {
    ctf: {
      pages: {
        categories: {
          title: "カテゴリ",
          subtitle: "CTF の問題カテゴリを監査項目とバックエンドフィルタ付きで管理します。",
          createAction: "カテゴリ作成",
          createTitle: "カテゴリ作成",
          createSuccess: "カテゴリを作成しました",
          archiveAction: "アーカイブ",
          archiveConfirmTitle: "このカテゴリをアーカイブしますか？",
          archiveConfirmDescription: "アーカイブ後は新しい問題を作成できません。履歴と監査記録は保持されます。",
          archiveSuccess: "カテゴリをアーカイブしました",
          loadFailed: "カテゴリの読み込みに失敗しました"
        }
      }
    }
  }
};
